//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// data-source-create imports
import { IContainer, IProps } from "./DataSourceCreate.d";
import { dataSourceCreateFragments } from "./DataSourceCreate.gql";
// state
import { IReduxState } from "@reducers/root.reducer";
// other internals
import { logger } from "@util/logger.util";
import GoogleBtn from "../google-btn";
import { createDataSource } from "@mutations";
import { track, TrackingEvents } from "@util/analytics.util";
import { snackBarOpen } from "@actions/snack-bar.actions";

//////////////////
// COMPONENT
//////////////////
class DataSourceCreateCmpt extends React.Component<IProps> {
  private onRelaySuccess = (createPayload: ISchema.ICreateDataSourceMutationPayload) => {
    if (!!createPayload.dataSourceAuthError && this.props.onError) {
      return this.props.onError(createPayload.dataSourceAuthError);
    } else if (!!createPayload.dataSourceAuthError) {
      return this.onRelayFailure(createPayload.dataSourceAuthError);
    }

    this.props.snackBarOpen("Your personal calendar is now connected and syncing.");
    track(TrackingEvents.SETTINGS.DATA_SOURCE_ADD);
    if (this.props.onSuccess) {
      this.props.onSuccess(createPayload);
    }
  };

  private onRelayFailure = (_error: any) => {
    this.props.snackBarOpen("There was a problem connecting this calendar as a personal calendar.");
    if (this.props.onError) {
      this.props.onError(ISchema.DataSourceAuthError.GenericError);
    }
  };

  private onGoogleSuccess = (response: any) => {
    const googleOfflineCode = response.code;
    const orgRelayId = this.props.org.id;
    if (this.props.onStartSave) {
      this.props.onStartSave();
    }
    createDataSource(
      this.props.relay.environment,
      { googleOfflineCode, orgRelayId, isPersonal: this.props.isPersonalDataSource },
      this.onRelaySuccess,
      this.onRelayFailure,
    );
  };

  public onGoogleFailure() {
    logger.debug("OAuth failure");
  }

  public render() {
    return (
      <GoogleBtn
        label={this.props.label || "connect new calendar"}
        onSuccess={this.onGoogleSuccess}
        onFailure={this.onGoogleFailure}
        isMenuItem={!!this.props.asListItem}
        primary={!!this.props.primary}
        fullWidth={!!this.props.fullWidth}
        flat={!!this.props.flat}
        style={this.props.style}
        labelStyle={this.props.labelStyle}
        icon={this.props.icon}
        disabled={this.props.disabled}
        backgroundColor={"transparent"}
        className={this.props.className}
        excludeAdminPermissions={this.props.isPersonalDataSource}
        excludeContactPermission={this.props.isPersonalDataSource}
      />
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const DataSourceCreateRedux = connect(mapStateToProps, {
  snackBarOpen,
})(DataSourceCreateCmpt);

//////////////////
// RELAY
//////////////////
export const DataSourceCreate = createFragmentContainer<IContainer>(
  DataSourceCreateRedux,
  dataSourceCreateFragments,
);
